<div class="min-h-screen flex items-center justify-center p-4 bg-[var(--beige)] overflow-hidden relative"
style="background-image: url('assets/fondo-rugoso.webp'); background-size: auto; background-position: center;">


  <div class="container-padding max-w-screen-desktop mx-auto w-full">
    <div class="flex justify-center items-center gap-2">
      <img src="assets/logo.webp" alt="Logo" class="w-20 mobile:24 mobile-m:w-28 tablet:w-32 desktop:w-40 h-auto">
      <img src="assets/mascota.webp" alt="Logo" class="w-20 mobile:24 mobile-m:w-28 tablet:w-32 desktop:w-40 h-auto">
    </div>
    @if (loading) {
      <div class="flex flex-col items-center justify-center min-h-[200px] gap-4">
        <div class="w-12 h-12 border-4 border-t-[var(--dark-orange)] border-[var(--black)] rounded-full animate-spin"></div>
        <p class="text-[var(--black)] text-lg">{{ 'feedback.loading' | translate }}</p>
      </div>
    }

    @if (error) {
      <div class="flex justify-center">     
        <div class="max-w-[600px] p-4 mobile-m:p-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)]">
          <div class="flex flex-col items-center justify-center text-center animate-fadeIn">
            <div class="text-4xl mobile-m:text-6xl mb-3 mobile-m:mb-6">😕</div>
            <h2 class="uppercase text-[28px]/[28px] mobile-m:text-[38px]/[55px] font-normal text-[var(--dark-orange)] mb-3 mobile-m:mb-6">
              {{ 'feedback.error' | translate }}
            </h2>
            <p class="text-[var(--black)] text-lg mb-4 mobile-m:mb-8">
              {{ error }}
            </p>
            <p class="text-gray-600">
              {{ 'feedback.redirecting' | translate }}
            </p>
          </div>
        </div>
      </div>
    }

    @if (submitted) {
      <div class="flex justify-center">  
        <div class="max-w-[600px] p-4 mobile-m:p-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)]">
          <div class="flex flex-col items-center justify-center py-12 text-center animate-fadeIn">
            <div class="text-6xl mb-6">🎉</div>
            <h2 class="uppercase text-[28px]/[28px] mobile-m:text-[38px]/[55px] font-normal text-[var(--dark-orange)] mb-3 mobile-m:mb-6">
              {{ 'feedback.thanks' | translate }}
            </h2>
            <p class="text-[var(--black)] text-lg mb-4 mobile-m:mb-8">
              {{ 'feedback.thanksDesc' | translate }}
            </p>
            <p class="text-gray-600">
              {{ 'feedback.redirecting' | translate }}
            </p>
          </div>
        </div>
      </div>
    }

    @if (!loading && !error && !submitted && feedbackData) {
      <div class="flex justify-center">
        <div class="max-w-[600px] p-4 mobile-m:p-6 shadow rounded-2xl sm:px-10 my-2 mobile-m:my-4 border border-4 border-[var(--black)] bg-[var(--white)]">
          <h2 class="uppercase text-[28px]/[28px] mobile-m:text-[38px]/[55px] font-normal text-[var(--dark-orange)]">
            {{ 'feedback.title' | translate }}
          </h2>
          <div class="w-full border-t border-dotted mb-3 mt-1 mobile-m:mb-6 mobile-m:mt-2"></div>

          <p class="text-[var(--black)] text-[16px]/[22px] mobile-m:text-[20px]/[24px] h-[44px] mobile-m:h-[24px] mb-3 mobile-m:mb-8">
            {{ 'feedback.reservationInfo' | translate: { locator: feedbackData.info.locator, userName: feedbackData.info.userName, itemName: feedbackData.info.itemName } }}
          </p>

          <!-- Progress bar -->
          <div class="w-full bg-gray-200 rounded-full h-1.5 mb-4 mobile-m:mb-8">
            <div class="bg-[var(--dark-orange)] h-1.5 rounded-full" 
                [style.width]="((currentStep + 1) / totalSteps * 100) + '%'">
            </div>
          </div>

          <!-- Current item -->
          @if (getCurrentItem(); as currentItem) {
            <div class="mb-4 mobile-m:mb-8 animate-fadeIn">
              <h3 class="uppercase text-[18px]/[24px] mobile-m:text-[24px]/[32px] font-normal text-[var(--dark-orange)] mb-2 mobile-m:mb-6">
                {{ 'feedback.stepOf' | translate: { current: currentStep + 1, total: totalSteps } }}
              </h3>
              
              <div class="">
                <h4 class="text-[16px]/[22px] mobile-m:text-[20px]/[24px] h-[44px] mobile-m:h-[24px] font-bold text-[var(--black)] mb-2 mobile-m:mb-4">{{ currentItem.name }}</h4>
                
                <div class="flex flex-col gap-3 mobile-m:gap-6">
                  <div class="flex flex-col">
                    <label class="text-[var(--black)] font-bold text-[14px]/[20px] mobile-m:text-[16px]/[22px] mb-2 mobile-m:mb-4">{{ 'feedback.rating' | translate }}</label>
                    <div class="flex items-center gap-2">
                      @for (rating of ratingOptions; track rating) {
                        <button 
                          type="button"
                          (click)="getCurrentFeedback()!.rating = rating"
                          (mouseenter)="hoverRating = rating"
                          (mouseleave)="hoverRating = 0"
                          class="text-3xl focus:outline-none transition-transform hover:scale-110"
                          [class.text-yellow-400]="rating <= (hoverRating || getCurrentFeedback()!.rating)"
                          [class.text-gray-300]="rating > (hoverRating || getCurrentFeedback()!.rating)"
                        >
                          ★
                        </button>
                      }
                      <span class="ml-2 text-sm text-gray-600">
                        {{ getCurrentFeedback()!.rating ? getCurrentFeedback()!.rating + ' ' + ('feedback.stars' | translate) : ('feedback.noRating' | translate) }}
                      </span>
                    </div>
                  </div>

                  <div class="flex flex-col">
                    <label class="text-[var(--black)] text-[14px]/[20px] mobile-m:text-[16px]/[22px] font-bold mb-1 mobile-m:mb-2">{{ 'feedback.comment' | translate }}</label>
                    <textarea [(ngModel)]="getCurrentFeedback()!.comment" rows="3"
                      class="w-full p-2 border-2 border-[var(--black)] rounded-lg focus:outline-none focus:border-[var(--dark-orange)]"
                      [placeholder]="'feedback.commentPlaceholder' | translate"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- Navigation buttons -->
            <div class="flex justify-between items-center mt-3 mobile-m:mt-8">
              <button *ngIf="currentStep > 0" (click)="goPrevious()"
                class="px-6 py-2 outline outline-2 outline-[var(--black)] text-[var(--black)] rounded-lg uppercase font-bold hover:bg-gray-100 transition-colors">
                {{ 'feedback.previous' | translate }}
              </button>
              <div class="flex-grow"></div>
              @if (!isLastStep()) {
                <button (click)="goNext()" [disabled]="!canGoNext()"
                  class="px-6 py-2 bg-[var(--dark-orange)] text-white rounded-lg uppercase font-bold disabled:opacity-50 disabled:cursor-not-allowed hover:brightness-110 hover:scale-105 transition-all">
                  {{ 'feedback.next' | translate }}
                </button>
              } @else {
                <button (click)="onSubmit()" [disabled]="!canSubmit() || submitting"
                  class="px-6 py-2 bg-[var(--dark-orange)] text-white rounded-lg uppercase font-bold disabled:opacity-50 disabled:cursor-not-allowed hover:brightness-110 hover:scale-105 transition-all">
                  {{ submitting ? ('feedback.sending' | translate) : ('feedback.finish' | translate) }}
                </button>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

<style>
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-out;
  }
</style>
